<style lang="scss">
.ql-editor {
  min-height: 200px;
}
</style>

<template>
  <div>
    <el-form
      ref="form"
      label-position="top"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 36 }" :md="{ span: 18 }" :lg="{ span: 12 }">
          <el-form-item label="消息模板名称" prop="msgTemplateName">
            <el-input
              clearable
              v-model="formData.msgTemplateName"
              placeholder="请输入消息模板名称"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 36 }" :md="{ span: 18 }" :lg="{ span: 12 }">
          <el-form-item label="消息模板类型" prop="msgTemplateType">
            <el-select
              v-model="formData.msgTemplateType"
              placeholder="请选择消息模板类型"
              style="width:100%"
            >
              <el-option label="短信" value="SMS" />
              <el-option label="邮件" value="mail" />
              <el-option label="微信推送" value="wechat" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="字段长度" prop="fieldLength">
            <el-input-number
              v-model="formData.fieldLength"
              placeholder="请输入字段长度"
              controls-position="right"
              style="width:100%"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="界面控件类型" prop="controlType">
            <el-select
              v-model="formData.controlType"
              placeholder="请选择界面控件类型"
            >
              <el-option
                label="文本框"
                value="input"
                key="input"
                :disabled="isMail"
              />
              <el-option label="富文本" value="html" key="html" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="模板状态" prop="msgTemplateStatus">
            <el-radio-group v-model="formData.msgTemplateStatus">
              <el-radio label="Y">已启用</el-radio>
              <el-radio label="N">未启用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="消息模板内容" prop="msgTemplateContent">
          <el-input
            v-if="!isHTML"
            v-model="formData.msgTemplateContent"
            type="textarea"
          >
          </el-input>
          <div v-if="isHTML">
            <quill-editor
              v-model="formData.msgTemplateContent"
              :options="editorOptions"
            />
          </div>
        </el-form-item>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
  components: {
    quillEditor,
  },
  props: {
    disabled: Boolean,
    msgTemplateCode: String,
  },
  data() {
    return {
      editorOptions: {
        modules: {
          toolbar: ['bold', 'italic', 'underline', 'strike'],
        },
      },
      isMail: false,
      backDialogVisible: false,
      formData: { msgTemplateStatus: 'Y' },
      rules: {
        msgTemplateName: [
          { required: true, message: '请输入消息模板名称', trigger: 'blur' },
        ],
        msgTemplateType: [
          { required: true, message: '请选择消息模板类型', trigger: 'change' },
        ],
        controlType: [
          { required: true, message: '请选择界面控件类型', trigger: 'change' },
        ],
        fieldLength: [
          { required: true, message: '请输入字段长度', trigger: 'blur' },
        ],
        msgTemplateContent: [
          { required: true, message: '请输入消息模板内容', trigger: 'blur' },
        ],
        msgTemplateStatus: [
          { required: true, message: '请选择模板状态', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    isHTML() {
      return this.formData.controlType === 'html'
    },
  },
  watch: {
    /**
     * 侦听消息模板类型，根据情况修改界面空间类型并禁用
     */
    'formData.msgTemplateType'() {
      if (this.formData.msgTemplateType === 'mail') {
        this.isMail = true
        this.formData.controlType = 'html'
      } else {
        this.isMail = false
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.msgTemplateCode) return
      this.$api
        .sysAlarmTemplateDetailApi({
          msgTemplateCode: this.msgTemplateCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .sysAlarmTemplateSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
